import { Record } from 'immutable';
export default Record({
  field: null,
  order: null
}, 'SearchSortRecord');